import { DriverOOJCredential } from './driver-ooj-credential.model';

export class DriverOOJCredentialRequest {

    public businessTransactionId: number;

    public executeImageCheck = false;

    public driverOOJCredential: DriverOOJCredential;
}
